// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fl","advertDetailContactGroup__header":"c-n_fm","advertDetailContactGroup__value":"c-n_fn"};